const $ = require('jquery');
const WS = require('./ws.js');

require('./altudo-performance.js');
require('./match-height-init.js');
require('./focus-handler.js');
require('./modernizr-custom-tests.js');
require('./custom-ko-bindings.js');
require('./custom-ko-functions.js');
require('es6-promise/auto');

require('../sass/blocks/accordion');
require('../sass/blocks/alert');
require('../sass/blocks/animations');
require('../sass/blocks/article');
require('../sass/blocks/chat');
require('../sass/blocks/chat.vm');
require('../sass/blocks/chat-event.vm');
require('../sass/blocks/chat-analytics');
require('../sass/blocks/circular-image');
require('../sass/blocks/cta-block');
require('../sass/blocks/dialog');
require('../sass/blocks/exit-dialog');
require('../sass/blocks/forms');
require('../sass/blocks/geo');
require('../sass/blocks/lazyload');
require('../sass/blocks/nav');
require('../sass/blocks/mega-menu');
require('../sass/blocks/nav-secondary');
require('../sass/blocks/parallax-effect');
require('../sass/blocks/pill');
require('../sass/blocks/banner');
require('../sass/blocks/search');
require('../sass/blocks/section');
require('../sass/blocks/share-link');
require('../sass/blocks/tabs');

require('../sass/distributors/blocks/login');

require('../vendors/sitecore/form.conditions');
require('../vendors/sitecore/form.tracking');

$(function () {
    const dynamicImports = [];
    const preloadAll = WS.isExperienceEditor();
    
    if (preloadAll || !window.CSS || !window.CSS.supports) {
        dynamicImports.push(import(/* webpackChunkName: "picturefill" */ "picturefill"));
    }

    if (preloadAll || $(".pagemode-edit").length > 0) {
        dynamicImports.push(import(/* webpackChunkName: "experience-editor" */ "./experience-editor"));
    }

    if (preloadAll || $("input[type=hidden].ws-agent").length > 0) {
        dynamicImports.push(import(/* webpackChunkName: "agent-detail" */ "../sass/blocks/agent-detail"));
    }

    if (preloadAll || $(".ws-carousel").length > 0) {
        dynamicImports.push(import(/* webpackChunkName: "ws-slick" */ "../sass/blocks/ws-slick"));
        dynamicImports.push(import(/* webpackChunkName: "carousel" */ "../sass/blocks/carousel"));
    }

    if (preloadAll || $(".ws-life-insurance-calculator, .ws-calculator").length > 0) {
        dynamicImports.push(import(/* webpackChunkName: "calculator" */ "../sass/blocks/calculator"));
        dynamicImports.push(import(/* webpackChunkName: "bspopover" */ "bootstrap/js/dist/popover"));
    }

    if (preloadAll || $(".ws-data-point-callout__chart").length > 0) {
        dynamicImports.push(import(/* webpackChunkName: "callout-chart" */ "../sass/blocks/data-point-callout"));
    }

    if (preloadAll || $(".ws-heading--collapsible").length > 0) {
        dynamicImports.push(import(/* webpackChunkName: "collapsible-content-blocks" */ "../sass/blocks/collapsible-content-blocks"));
    }

    if (preloadAll || $(".ws-content-indicator").length > 0) {
        dynamicImports.push(import(/* webpackChunkName: "content-indicator" */ "../sass/blocks/content-indicator"));
    }

    if (preloadAll || $(".ws-content-library").length > 0) {
        dynamicImports.push(import(/* webpackChunkName: "content-library" */ "../sass/blocks/content-library"));
    }

    if (preloadAll || $(".ws-content-library-review").length > 0) {
        dynamicImports.push(import(/* webpackChunkName: "content-library-review" */ "../sass/blocks/content-library-review"));
    }

    if (preloadAll || $(".ws-cta-block").length > 0) {
        dynamicImports.push(import(/* webpackChunkName: "cta-block" */ "../sass/blocks/cta-block"));
    }

    if (preloadAll || $(".ws-cta-persistent").length > 0) {
        dynamicImports.push(import(/* webpackChunkName: "cta-persistent" */ "../sass/blocks/cta-persistent"));
    }

    if (preloadAll || $(".ws-form__element-datepicker").length > 0) {
        dynamicImports.push(import(/* webpackChunkName: "datepicker" */ "../sass/blocks/datepicker"));
    }

    if (preloadAll || $(".ws-form__file-upload").length > 0) {
        dynamicImports.push(import(/* webpackChunkName: "file-upload" */ "../sass/blocks/file-upload"));
    }

    if (preloadAll || $(".ws-in-page-nav, .ws-body--minified-header .ws-minified-header, .ws-clustered-table-of-contents").length > 0) {
        dynamicImports.push(import(/* webpackChunkName: "in-page-nav" */ "../sass/blocks/in-page-nav"));
    }

    if (preloadAll || $(".ws-learn-articles").length > 0) {
        dynamicImports.push(import(/* webpackChunkName: "learn-articles" */ "../sass/blocks/learn-articles"));
    }

    if (preloadAll || $(".ws-literature-center").length > 0) {
        dynamicImports.push(import(/* webpackChunkName: "literature-center" */ "../sass/blocks/literature-center"));
    }

    if (preloadAll || $(".ws-literature-review").length > 0) {
        dynamicImports.push(import(/* webpackChunkName: "literature-review" */ "../sass/blocks/literature-review"));
    }

    if (preloadAll || $(".ws-myga--chart").length > 0) {
        dynamicImports.push(import(/* webpackChunkName: "myga" */ "../sass/blocks/myga"));
    }

    if (preloadAll || $(".ws-nav-tabs").length > 0) {
        dynamicImports.push(import(/* webpackChunkName: "nav-tabs" */ "../sass/blocks/nav-tabs"));
    }

    if (preloadAll || $(".ws-news-articles").length > 0) {
        dynamicImports.push(import(/* webpackChunkName: "news-articles" */ "../sass/blocks/news-articles"));
    }

    if (preloadAll || $(".ws-newsletter-signup").length > 0) {
        dynamicImports.push(import(/* webpackChunkName: "newsletter-signup" */ "../sass/blocks/newsletter-signup"));
    }

    if (preloadAll || $(".ws-ol-map").length > 0) {
        dynamicImports.push(import(/* webpackChunkName: "office-listing" */ "../sass/blocks/office-listing"));
    }

    if (preloadAll || $(".ws-ol-map").length > 0 || $(".ws-contact-card__map").length > 0 || $(".ws-agent-detail__sidebar__map").length > 0) {
        dynamicImports.push(import(/* webpackChunkName: "office" */ "../sass/blocks/office"));
    }

    if (preloadAll || $(".ws-eagle-map__map").length > 0) {
        dynamicImports.push(import(/* webpackChunkName: "eagle-interactive-property" */ "../sass/blocks/eagle-map-init"));
    }

    if (preloadAll || $("[data-ws-toggle='popover']").length > 0) {
        dynamicImports.push(import(/* webpackChunkName: "popover" */ "../sass/blocks/popover"));
    }

    if (preloadAll || $(".ws-search-results").length > 0) {
        dynamicImports.push(import(/* webpackChunkName: "search-results" */ "../sass/blocks/search-results"));
    }

    if (preloadAll || $(".ws-share").length > 0) {
        dynamicImports.push(import(/* webpackChunkName: "share" */ "../sass/blocks/share"));
    }

    if (preloadAll || $(".ws-survey").length > 0) {
        dynamicImports.push(import(/* webpackChunkName: "survey" */ "../sass/blocks/survey"));
    }
    
    if (preloadAll || $(".ws-table-of-contents, .ws-clustered-table-of-contents").length > 0) {
        dynamicImports.push(import(/* webpackChunkName: "table-of-contents" */ "../sass/blocks/table-of-contents"));
    }

    if (preloadAll || $(".ws-thought-leadership-articles").length > 0) {
        dynamicImports.push(import(/* webpackChunkName: "thought-leadership-articles" */ "../sass/blocks/thought-leadership-articles"));
    }

    if (preloadAll || typeof fundDetailTarget !== "undefined") {
        dynamicImports.push(import(/* webpackChunkName: "tsi-fund-detail" */ "../sass/tsi/blocks/fund-detail"));
    }

    if (preloadAll || typeof etfDetailTarget !== "undefined") {
        dynamicImports.push(import(/* webpackChunkName: "tsi-etf-detail" */ "../sass/tsi/blocks/etf-detail"));
    }

    if (preloadAll || $(".ws-fund-overview").length > 0) {
        dynamicImports.push(import(/* webpackChunkName: "tsi-fund-overview" */ "../sass/tsi/blocks/fund-overview"));
    }

    if (preloadAll || $(".ws-contact-a-rep").length > 0) {
        dynamicImports.push(import(/* webpackChunkName: "wsl-contact-a-rep" */ "../sass/wsl/blocks/contact-a-rep"));
    }

    if (preloadAll || $(".ws-find-a-rep").length > 0) {
        dynamicImports.push(import(/* webpackChunkName: "wsl-find-a-rep" */ "../sass/wsl/blocks/find-a-rep"));
    }

    if (preloadAll || $(".ws-one-time-payment").length > 0) {
        dynamicImports.push(import(/* webpackChunkName: "ws-one-time-payment" */ "../sass/wsl/blocks/one-time-payment"));
    }

    if (preloadAll || $(".ws-responsive-table, .footable, [class*='ws-rte-responsive-table']").length > 0) {
        dynamicImports.push(import(/* webpackChunkName: "table" */ "../sass/blocks/table"));
    }

    if (preloadAll || $(".ws-animation-number--flip").length > 0) {
        dynamicImports.push(import(/* webpackChunkName: "animations" */ "../sass/blocks/animations"));
    }

    if (preloadAll || $(".ws-claims-wizard").length > 0) {
        dynamicImports.push(import(/* webpackChunkName: "claims-wizard" */ "../sass/blocks/claims-wizard"));
    }

    if (preloadAll || $(".ws-lf").length > 0) {
        dynamicImports.push(import(/* webpackChunkName: "legacy-forward" */ "../sass/blocks/legacy-forward"));
    }

    Promise.all(dynamicImports).then(function () {
        const event = document.createEvent("Event");
        WS.scriptBundleLoaded = true;
        event.initEvent("WsScriptBundleLoaded", true, true);
        document.dispatchEvent(event);
    });

   
});